<template>
  <el-dialog width="30%" class="wxinfo" title="录入发货信息" :visible.sync="isShow">
    <div class="dialog-body" v-if="WXInfoData">
      <div class="order-info">
        <p class="order-row">
          <span class="row-title">商户单号</span>
          <span class="row-content">
            {{ WXInfoData.merchant_trade_no }}
            (商户号 {{ WXInfoData.sub_merchant_id }})
          </span>
        </p>
        <p class="order-row">
          <span class="row-title">交易单号</span>
          <span class="row-content">
            {{ WXInfoData.transaction_id }}
          </span>
        </p>
        <p class="order-row">
          <span class="row-title">支付金额</span>
          <span class="row-content"> ￥{{ WXInfoData.paid_amount / 100 }} </span>
        </p>
        <p class="order-row">
          <span class="row-title">支付时间</span>
          <span class="row-content">
            {{ new Date(WXInfoData.pay_time * 1000).pattern("yyyy-MM-dd HH:mm:ss") }}
          </span>
        </p>
      </div>
      <el-form
        ref="WXInfoForm"
        :model="WXInfoForm"
        :rules="WXInfoFormRules"
        label-width="120px"
      >
        <el-form-item label="商品信息：" prop="itemDesc">
          <el-input
            v-model="WXInfoForm.itemDesc"
            :show-word-limit="true"
            resize="none"
            rows="3"
            maxlength="120"
            type="textarea"
            placeholder="商品信息会向用户展示，请保持和订单信息一致。输入多个商品时用“;“隔开"
          ></el-input>
        </el-form-item>
        <el-form-item label="未成团发货">
          <el-radio-group v-model="WXInfoForm.logisticsType">
            <el-radio :label="1">物流快递</el-radio>
            <el-radio :label="2">同城配送</el-radio>
            <el-radio :label="4">用户自提</el-radio>
            <el-radio :label="3">虚拟商品</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="快递信息"
          prop="trackingNo"
          v-if="WXInfoForm.logisticsType == 1"
        >
          <div class="row-flex">
            <el-select
              placeholder="请选择快递公司"
              filterable
              v-model="WXInfoForm.expressCompany"
              style="margin-right: 10px"
            >
              <el-option
                v-for="item in deliveryListFromWX"
                :key="item.delivery_id"
                :label="item.delivery_name"
                :value="item.delivery_id"
              ></el-option>
            </el-select>
            <el-input
              placeholder="快递单号"
              v-model.trim="WXInfoForm.trackingNo"
              clearable
            ></el-input>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取 消</el-button>
      <el-button type="primary" @click="WXInfoSubmit">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getDeliveryListFromWX, uploadShippingInfoToWX } from "@/api/index";

export default {
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
    WXInfoData: null,
  },
  data() {
    return {
      WXInfoForm: {
        itemDesc: "",
        logisticsType: 1,
        expressCompany: "",
        trackingNo: "",
      },
      WXInfoFormRules: {
        itemDesc: [{ required: true, message: "请输入商品信息", trigger: "blur" }],
        trackingNo: [{ required: true, message: "请输入快递单号", trigger: "blur" }],
      },
      deliveryListFromWX: [],
    };
  },
  computed: {},
  watch: {
    isShow(val) {
      if (!val) {
        (this.WXInfoData = null),
          (this.WXInfoForm = {
            itemDesc: "",
            logisticsType: 1,
            expressCompany: "",
            trackingNo: "",
          });
      }
    },
    WXInfoData(val) {
      if (val) {
        this.WXInfoForm.itemDesc = val.productSubject;
      }
    },
  },
  mounted() {
    this.getDeliveryListFromWX();
  },

  methods: {
    getDeliveryListFromWX() {
      getDeliveryListFromWX().then((res) => {
        if (res.code == 1) {
          this.deliveryListFromWX = res.data.delivery_list;
        }
      });
    },
    WXInfoSubmit() {
      this.$refs.WXInfoForm.validate((valid) => {
        if (!valid) {
          this.$notify({
            title: "提示",
            message: "请输入相应信息",
            type: "warning",
            duration: 1000,
          });
          return;
        }
        let params = {
          mallOrderId: this.WXInfoData.mallOrderId,
          shippingContent: JSON.stringify({
            order_key: {
              order_number_type: 1,
              mchid: this.WXInfoData.merchant_id,
              out_trade_no: this.WXInfoData.merchant_trade_no,
            },
            delivery_mode: 1,
            logistics_type: this.WXInfoForm.logisticsType,
            is_all_delivered: false,
            shipping_list: [
              {
                tracking_no: this.WXInfoForm.trackingNo,
                express_company: this.WXInfoForm.expressCompany,
                item_desc: this.WXInfoForm.itemDesc,
                contact: {
                  receiver_contact: this.maskNumber(this.WXInfoData.buyerPhone),
                },
              },
            ],
            upload_time: new Date().pattern("yyyy-MM-ddTHH:mm:ss.S+08:00"),
            payer: {
              openid: this.WXInfoData.openid,
            },
          }),
        };
        console.log(111, params);
        uploadShippingInfoToWX(params).then((res) => {
          if (res.code == 1) {
            this.$notify({
              title: "提示",
              message: "录入成功",
              type: "success",
              duration: 1000,
            });
            this.refreshGetData();
          } else {
            this.$notify({
              title: "提示",
              message: res.msg,
              type: "error",
              duration: 2000,
            });
          }
        });
      });
    },
    maskNumber(phoneNumber) {
      if (phoneNumber.match(/^(\d{3})\d{4}(\d{4})$/)) {
        return phoneNumber.replace(/^(\d{3})\d{4}(\d{4})$/, "$1****$2");
      } else if (phoneNumber.match(/^(\d{3}-)\d{4}(\d{4})$/)) {
        return phoneNumber.replace(/^(\d{3}-)\d{4}(\d{4})$/, "$1****$2");
      } else if (phoneNumber.match(/^\d{4}(\d{4})$/)) {
        return phoneNumber.replace(/^\d{4}(\d{4})$/, "****$1");
      } else if (phoneNumber.match(/^(\d)(\d)(\d)(\d)-\d{3}(\d{4})$/)) {
        return phoneNumber.replace(/^(\d)(\d)(\d)(\d)-\d{3}(\d{4})$/, "$1**$4-***$5");
      } else if (phoneNumber.match(/^(\d)(\d)(\d)(\d)-\d{6}(\d{2})-(\d{2})$/)) {
        return phoneNumber.replace(
          /^(\d)(\d)(\d)(\d)-\d{6}(\d{2})-(\d{2})$/,
          "$1**$4-******$5-$6"
        );
      } else if (phoneNumber.match(/^\d{4}(\d{3})-(\d{4})$/)) {
        return phoneNumber.replace(/^\d{4}(\d{3})-(\d{4})$/, "****$1-$2");
      }
    },
    refreshGetData() {
      this.$emit("refreshGetData");
      this.closeDialog();
    },
    closeDialog() {
      this.$emit("closeDialog");
    },
  },
};
</script>

<style lang="less" scoped>
.wxinfo {
  .dialog-body {
    .order-info {
      padding: 10px;
      background-color: rgba(0, 0, 0, 0.1);
      border-radius: 10px;
      margin-bottom: 10px;
    }
    .row-flex {
      display: flex;
    }
  }
}
</style>

<style lang="less">
.wxinfo {
  .el-dialog__body {
    padding: 10px 20px;
  }
}
</style>
